// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1m-t4","select":"Header_select__1P6HL","clinic":"Header_clinic__N9wl7"};